import axios from 'axios';

export const commentService = {
  getComments: (taskId) =>
    axios.get('/comments', { auth: true, params: { task: taskId } }),
  createComment: (data) =>
    axios.post('/comments', data, { auth: true }),
  updateComment: (id, data) =>
    axios.patch(`/comments/${id}`, data, { auth: true }),
  deleteComment: (id) =>
    axios.delete(`/comments/${id}`, { auth: true }),
  getUnresolvedCounts: (taskIds) =>
    axios.get('/comments/unresolved-counts', { auth: true, params: { tasks: taskIds.join(',') } }),
};
